import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lr-number',
  templateUrl: './lr-number.component.html',
  styleUrls: ['./lr-number.component.scss']
})
export class LRNumberComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/lr-number/lr-number.component.ts